/**
 * Utilities for constructing triage agent related URLs
 */

type TriageAgentUrlParams = {
  repoOwner: string
  repoName: string
  defaultBranch?: string
}

/**
 * Constructs URL to view or edit existing triage-agent.md configuration file
 */
export function getTriageAgentConfigUrl({repoOwner, repoName, defaultBranch = 'main'}: TriageAgentUrlParams): string {
  // Should align with TriageAgent::CONFIG_FILE_PATH
  return `/${repoOwner}/${repoName}/blob/${defaultBranch}/.github/triage-agent.md`
}

/**
 * Constructs URL to create new triage-agent.md configuration file
 */
export function getNewTriageAgentConfigUrl({
  repoOwner,
  repoName,
  defaultBranch = 'main',
}: TriageAgentUrlParams): string {
  return `/${repoOwner}/${repoName}/new/${defaultBranch}?triage-agent=1`
}
